let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aeSLG")).then(() => parcelRequire('5snLG'));